import React from 'react'
import ReportCallFeePage from "./ReportCallFeePage"

function ReportCallFeeContainer(props) {
    const {location} = props
    const {search} = location
    const params = search ? Object.fromEntries(new URLSearchParams(search)) : ""
    const custId = params?.custId || ''
    const custName = params?.custName || ''

    return (
        <div className="ReportByDayContainer">
            <ReportCallFeePage custId={custId} custName={custName}/>
        </div>
    )
}

export default ReportCallFeeContainer
